import { render } from "./MyInstall.vue?vue&type=template&id=05ce6305"
import script from "./MyInstall.vue?vue&type=script&lang=js"
export * from "./MyInstall.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__